import { render, staticRenderFns } from "./MoleculeDashboardConfigurationItem.vue?vue&type=template&id=465e4580&scoped=true&"
import script from "./MoleculeDashboardConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./MoleculeDashboardConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeDashboardConfigurationItem.vue?vue&type=style&index=0&id=465e4580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e4580",
  null
  
)

export default component.exports